import { styled } from '@f8n-frontend/stitches';

import Box from 'components/base/Box';

const Grid = styled(Box, { display: 'grid' });

export default Grid;
